import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../../constants/routes';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { getNotifications } from '../../../store/reducers/Notifications/slice';
import * as log from '../../../utils/log';
import NotificationLabel from '../../../views/NotificationView/NotificationLabel/NotificationLabel';
import Button from '../../Button/Button';
import Modal from '../../Modal/Modal';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import styles from './NotificationModal.module.scss';
const NotificationModal = ({ closeModal }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { userNotifications, limit, metaData: { page } } = useAppSelector((state) => state.notifications);
    const handleClick = () => {
        closeModal();
        navigate(Routes.NOTIFICATIONS);
    };
    useEffect(() => {
        dispatch(getNotifications({ page, limit }));
    }, [dispatch, limit, page]);
    useEffect(() => {
        log.debug(userNotifications);
    }, [userNotifications]);
    return (_jsxs(Modal, Object.assign({ className: styles.element, closeModal: closeModal }, { children: [_jsx(Paragraph, { className: styles.notifications, size: 1, title: t('notifications').toLocaleUpperCase() }), _jsxs("div", Object.assign({ className: 'd-flex flex-column' }, { children: [userNotifications &&
                        userNotifications.map((data) => (_jsx(NotificationLabel, { isModal: true, onLinkClick: closeModal, notification: data }, data.id))), _jsx(Button, { onClick: () => handleClick(), size: '100', className: cn('d-flex justify-content-center align-items-center', styles.notify), color: 6, text: t('see_all_notifications') })] }))] })));
};
export default NotificationModal;
